import comun from "./comun/config.js";
import { getTenant } from "./getTenant";
import { getEnvironment } from "./getEnvironment";

let cachedConfig = null;

export async function cargarConfig() {
  if (cachedConfig) return cachedConfig;

  const tenant = getTenant();     // ex: "tenant1"
  const env = getEnvironment();   // "dev" or "prod"

  // ---------------------------------------
  // Load tenant-only config
  // ---------------------------------------
  const tenantBase = await import(`./${tenant}/${tenant}.js`)
    .then(m => m.default)
    .catch(() =>
      import(`./comun/config.js`).then(m => m.default)
    );

  // ---------------------------------------
  // Load tenant+environment config
  // ---------------------------------------
  const tenantEnv = await import(`./${tenant}/${tenant}.${env}.js`)
    .then(m => m.default)
    .catch(() =>
      import(`./comun/config.js`).then(m => m.default)
    );

  // ---------------------------------------
  // Merge in correct order:
  // common → tenant-only → tenant+env
  // ---------------------------------------
  cachedConfig = {
    ...comun,
    ...tenantBase,
    ...tenantEnv,
    tenant,
    env
  };

  return cachedConfig;
}